<span class="spinner-border text-primary spinner-border-lg w-45px h-45px"></span>
<!--<span *ngIf="!element.action_active" class="spinner-border text-primary spinner-border-lg w-45px h-45px"></span>-->

<!--<ng-container *ngIf="!table && element.action_active">-->
<!--    &lt;!&ndash; ACTION INLINE &ndash;&gt;-->
<!--&lt;!&ndash;    <manager-action class="content d-flex flex-column flex-column-fluid p-0" [action]="element.action_active" [ressource]="element"></manager-action>&ndash;&gt;-->
<!--</ng-container>-->
